
import React, { createRef, useEffect, useMemo, useRef, useState } from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Divider, InputAdornment, ListItemText, OutlinedInput, Tab, TablePagination, TextareaAutosize, useRadioGroup, useStepContext } from '@mui/material';
import { LoadingButton, TabContext, TabList, TabPanel } from '@mui/lab';
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, Checkbox, CardContent, Card, List, Table, Stack, Button, TableRow, TableBody, TableCell, Container, Typography, ListItem, TableContainer, FormControl, Paper, InputLabel, MenuItem, Select, Grid, Box, Dialog, DialogActions, DialogContent, DialogTitle, TableHead, Breadcrumbs, Link } from '@mui/material';
import { getCamerasList, getClientList } from 'src/api/analytics';
import Scrollbar from 'src/components/Scrollbar';

import { getProtocols, setAddProtocol, getClientInfo, setSaveProtocol, getClientProtocolsInfoActions, deleteMessage, setMultiDevicesProtocol, updateDeviceProtocolsInfo, addProtocolActions, getProtocolInfoActions, updateProtocolActions, deleteProtocolActions, updateClientProtocolActions, deleteClientProtocolActions, addUpdateProtocolActions, UpdateMessage, DeleteDeviceMapping } from 'src/api/protocol';
import { getClientInfo as clientGroupInfo } from 'src/api/groups';
import { Field } from 'formik';
import { CompressOutlined, Label, TableRows, ViewKanban, VpnLock } from '@mui/icons-material';
import { filter, last, set } from 'lodash';
import CloseIcon from '@mui/icons-material/Close';
import client from 'src/api/clients';
//import { getDevices } from 'src/api/devices';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { getClientGroupInfo } from 'src/api/liveCameras';
import { getClientProperties } from 'src/api/ShiftMaster';
import { useTheme, alpha } from '@mui/material/styles';
import Page from "src/components/Page";
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const protoIcon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const protoCheckedIcon = <CheckBoxIcon fontSize="small" />;


const Protocols = ({isReseller}) => {
  
  const theme = useTheme();
  const resellerClientType = (localStorage.getItem('client_type') || '').toUpperCase();
  const effectiveResellerClientType = resellerClientType === 'INDIA' ? 'INDIA' : 'US';

  const [setClient, setSelectedClient] = useState([]);
  const [setTypeClient, setSelectedTypeClient] = useState([]);

  const [clientName, selectedClientName] = useState([]);
  const [cameraList, setCameras] = useState([]);
  const [selectedCamesList, setCamsList] = useState([]);
  const [selectedCamItems, setCamSelectedItems] = useState([]);


  const [protocolList, setProtocols] = useState([]);
  const [open, setOpen] = useState(false);
  const [newProtocolname, setNewProtoName] = useState('');
  const [selectedProto, setSelectedProtocol] = useState([]);
  const [protocolInfo, setProtocolInfo] = useState('');



  const [clientInfo, setClientDetails] = useState([]);

  const [groupInfo, setgroupInfo] = useState([])
  const [clientGroups, setClientGroups] = useState([])

  // Form Fields

  ////console.log("selected Cam Items",selectedCamItems);

  // police Number 
  const [policeno, setPoliceNo] = useState('');

  //mobile number 
  const [mobileno, setMobileNo] = useState('');
  const [originalProtocolData, setOriginalProtocolData] = useState([]);
  //emil Change

  const [email, setEmail] = useState('');

  //Fire Number
  const [fireNo, setFireNo] = useState('');

  const [primarySpocContact, setPrimarySpocContact] = useState('');
  const [secondaryPocContact, setSecondaryPocContact] = useState('');
  const [onsiteMaintenanceSupportContact, setOnsiteMaintenanceSupportContact] = useState('');
  const [onsiteSpeakerTestingSpoc, setOnsiteSpeakerTestingSpoc] = useState('');
  const [localNonEmergencyContact, setLocalNonEmergencyContact] = useState('');
  const [fireDepartmentContact, setFireDepartmentContact] = useState('');
  const [securityPatrolContact, setSecurityPatrolContact] = useState('');

  // address
  const [address, setAddress] = useState('');

  // Client ID mandatory 
  const [isClientSelected, setIsClientSelected] = useState(false); // State variable to track client selection
  const [saveError, setSaveError] = useState(false); // State to track save error

  // Add new protocol Error
  const [protocolNameError, setProtocolNameError] = useState(false);


  // protocol Messages
  const [data, setData] = useState([])
  const [assignedProtocols, setAssignedProtocols] = useState([]);


  const [message1, setMessage1] = useState('');
  const [message2, setMessage2] = useState('');
  const [message3, setMessage3] = useState('');


  const [errorCams, setErrorCams] = useState('')
  const [openError, setOpenError] = useState(false)

  const [list, setList] = useState([])
  const [header, setHeader] = useState('')

  const [deviceHist, setDeviceHist] = useState({})

  const [showConfirm, setShowConfirm] = useState(false)

  const [protocolError, setProtocolError] = useState('')

  const [policenoTextFields, setPolicenoTextFields] = useState(1);

  const [activeCameras, setActiveCameras] = useState([])
  const [inputValue, setInputValue] = useState([]);
  const [checkValue, setCheckValue] = useState(false)

  const [checkProtoValue, setCheckProtoValue] = useState(false)
  const [activeProto, setActiveProto] = useState([])

  const [assignProtocol, setAssignProtocol] = useState(false)
  const [addProtocol, setAddProtocol] = useState(false)

  const [addMessage, setAddMessage] = useState(false)

  const [groupList, setGroupList] = useState([])

  const [removeData, setRemoveData] = useState([])
  const [delProto, setDelProto] = useState(false)

  const [displayedData, setDisplyedData] = useState([])

  const [detectionTypeExistsError, setDetectionTypeExistsError] = useState(false);
  const [detectionTypeError, setDetectionTypeError] = useState(false);
  const [action1Error, setAction1Error] = useState(false);

  const [clientProtocolAction1Error, setClientProtocolAction1Error] = useState(false);

  const [originalDataNew, setOriginalDataNew] = useState([])

  const handleCloseError = () => {
    setOpenError(false)
  }

  const [clientType, setClientType] = useState('')
  const [clientTypeerror, setClientTypeError] = useState(false)


  const [existingDeviceIntoID, setExistingDevicesIntoID] = useState([])

  ////console.log("Introsion Messages",existingDeviceIntoID);
  ////console.log("selectedProto",selectedProto);

  const [deviceDataExist, setDeviceDataExist] = useState(false);
  const [groupCamerasInfo, setGroupCamersInfo] = useState([])
  const [clientLocationOptions, setClientLocationOptions] = useState([]);
  const [selectedClientLocations, setSelectedClientLocations] = useState([]);
  const [locationCheckValue, setLocationCheckValue] = useState(false);
  const [selectedGroupOption, setSelectedGroupOption] = useState(null);

  const getEffectiveClientType = () => (isReseller ? effectiveResellerClientType : clientType);

  const [messageErrors, setMessageErrors] = useState({});

  const [showMessage, setShowMessage] = useState(false)

  const handlePoliceNoChange = (event) => {
    setPoliceNo(event.target.value);
  };


  const handleMobileChange = (event) => {
    setMobileNo(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleFireChange = (event) => {
    setFireNo(event.target.value);
  };

  const handleAddressChange = (event) => {
    setAddress(event.target.value);
  };

  useEffect(() => {

    getClientList((response) => {
      if (response.status === 200) {
        setSelectedClient(response.data)
      }
    })

    getCamerasList((response) => {
      if (response.status === 200) {
        setCameras(response.data)
      }
    })

  }, [])

  useEffect(() => {
    const effectiveType = getEffectiveClientType();
    if (effectiveType === "INDIA") {
      // console.log("clientType",clientType)
      const indiaClients = setClient.filter((row) => row.ClientType === 'INDIA' && row.EnvironmentType !==0);
      const sortedData = [...indiaClients].sort((a, b) =>
        a.displayname.trim().localeCompare(b.displayname.trim())
      )
      setSelectedTypeClient(sortedData)

    }
    else if(effectiveType === "US") {
      const usClients = setClient.filter((row) => row.ClientType === 'US' && row.EnvironmentType !==0);
      const sortedData = [...usClients].sort((a, b) =>
        a.displayname.trim().localeCompare(b.displayname.trim())
      )
      setSelectedTypeClient(sortedData)


    }

  }, [clientType,assignProtocol,isReseller,setClient,effectiveResellerClientType])

  const [clientAvail, setClientAvail] = useState(false)

  const normalizeLocations = (responseData) =>
    Array.from(
      new Map(
        (Array.isArray(responseData) ? responseData : (responseData ? [responseData] : []))
          .map((locationItem) => ({
            ...locationItem,
            ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
            Location: String(locationItem?.Location || locationItem?.name || '').trim(),
          }))
          .filter((locationItem) => locationItem.ID > 0)
          .map((locationItem) => [locationItem.ID, locationItem])
      ).values()
    );

  const getDirectCamerasByLocationIds = (locationIds = []) => {
    const locationIdSet = new Set((locationIds || []).map((id) => String(id)));
    return (cameraList || []).filter((camera) => {
      const deviceClientId = String(camera?.clientid ?? camera?.client_id ?? camera?.ClientId ?? '');
      return deviceClientId !== '' && locationIdSet.has(deviceClientId);
    });
  };

  const loadGroupsForSelection = (clientId, selectedLocationIds = []) => {
    const hasLocations = Array.isArray(selectedLocationIds) && selectedLocationIds.length > 0;

    if (!clientId && !hasLocations) {
      setGroupList([]);
      setGroupCamersInfo([]);
      setSelectedGroupOption(null);
      setCamsList([]);
      return;
    }

    const body = {
      clientId: hasLocations ? selectedLocationIds.join(',') : clientId,
      groupId: 0,
    };

    getClientGroupInfo(body, (response) => {
      if (response.status === 200 && response.data.length > 0) {
        setGroupCamersInfo(response.data);
        const uniqueResult = Array.from(
          new Map(
            response.data.map((item) => [
              item.GroupId,
              { GroupId: item.GroupId, GroupName: item.GroupName },
            ])
          ).values()
        );
        setGroupList(uniqueResult);
        setCamsList([]);
      } else {
        setGroupList([]);
        setGroupCamersInfo([]);
        setSelectedGroupOption(null);

        if (hasLocations) {
          setCamsList(getDirectCamerasByLocationIds(selectedLocationIds));
        } else {
          const matchedCameras = cameraList.filter(
            (camera) => Number(camera.clientid) === Number(clientId)
          );
          setCamsList(matchedCameras);
        }
      }
    });
  };


  useEffect(() => {
    // console.log("===============================",clientName.ID);
    if (clientName.ID) {
      setGroupList([])
      setGroupCamersInfo([])
      setSelectedGroupOption(null)
      setCamsList([])

      getClientProperties({ AssignClient: String(clientName.ID) }, (response) => {
        let normalizedLocations = [];

        if (response.status === 200) {
          normalizedLocations = normalizeLocations(response.data);
          setClientLocationOptions(normalizedLocations);
        } else {
          setClientLocationOptions([]);
        }

        setSelectedClientLocations([]);
        setLocationCheckValue(false);

        if (normalizedLocations.length > 0) {
          return;
        }

        loadGroupsForSelection(clientName.ID, []);
      });
    }

    else {
      setClientLocationOptions([]);
      setSelectedClientLocations([]);
      setLocationCheckValue(false);
      setGroupList([]);
      setGroupCamersInfo([]);
      setSelectedGroupOption(null);
      setCamsList([]);
    }

    if (clientName.ID !== undefined && clientName.ID !== null) {
      getClientInfo(clientName.ID, (response) => {
        if (response.status === 200) {
          setClientDetails(response.data);
        }
      })
    }
    else {
      setClientDetails([])
    }
  }, [cameraList, clientName])

  useEffect(() => {
    // console.log('clientAvail',clientAvail);
    // console.log('protocol List',protocolList);
  }, [clientAvail])

  const jsonToFormData = (data) => {
    let formdata = new FormData()
    for (let x in data)
      formdata.append(x, data[x])
    return formdata
  }

  useEffect(() => {
    if (data.length > 0) {
      const displayedData = data;
      setDisplyedData(displayedData)
    }
    else {
      setDisplyedData([])
    }
  }, [data])


  useEffect(() => {
    clientProtocolListing();
  }, [activeCameras, activeProto])

  const clientProtocolListing = () => {
    let params = {}

    if (activeProto.length > 0 && activeCameras.length === 0) {
      console.log('condition1');
      params = {
        device_id: [],
        intrusion_id: activeProto.join(',')
      };

      ////console.log(protocolList)

      if (protocolList.length > 0) {

        const IntrusionInfo = protocolList.filter(item => activeProto.includes(item.Id))
        if (IntrusionInfo.length > 0) {
          setAssignedProtocols(IntrusionInfo)
          return;
        }
      }

    }
    else if (activeCameras.length > 0 && activeProto.length > 0) {
      console.log('condition2');
      //let deviceIds = selectedCamItems.map(item => item.deviceid);

      params = {
        device_id: activeCameras,
        intrusion_id: activeProto.join(',')
      };

      //setDeviceDataExist(true) commented on 2024-11-10

    }
    else if (activeCameras.length > 0 && activeProto.length === 0) {
      console.log('condition3');
      //  let deviceIds = selectedCamItems.map(item => item.deviceid);

      params = {
        device_id: activeCameras,
        intrusion_id: 0
      };

      //setDeviceDataExist(true) commented on 2024-11-10
    }

    if (Object.keys(params).length) {

      const protocolParams = {
        mapped_action_id: 0
      };

      getClientProtocolsInfoActions(protocolParams, (response) => {
        console.log('activeProto:', JSON.stringify(activeProto))
        console.log('deviceId:', JSON.stringify(params.device_id))
        if (response.status === 200) {
          if (response.data.length > 0) {
            const protocolsData = trimProtocolData(response.data)
            console.log('device_ids:', params.device_id);
            // filter with params device_id in protocolsData
            // If params.device_id is defined and non-empty, filter protocolsData entries to only those whose device_id is in params.device_id

            let filteredProtocolsData = protocolsData;
            if (
              params &&
              params.device_id &&
              Array.isArray(params.device_id) &&
              params.device_id.length > 0
            ) {
              // some objects may use a different field, ensure protocolsData objects have device_id property
              filteredProtocolsData = protocolsData.filter((item) =>
                params.device_id.includes(item.DeviceId)
              );
            }


            console.log('filterProtocolsDataCount length:', filteredProtocolsData.length)
            if (filteredProtocolsData.length > 0) {
              // Also filter through params.intrusion_id if it's set/nonzero.
              let filteredAndIntrusionFiltered = filteredProtocolsData;

              if (
                params &&
                activeProto &&
                Array.isArray(activeProto) &&
                activeProto.length > 0
              ) {
                // some objects may use a different field, ensure protocolsData objects have device_id property
                filteredAndIntrusionFiltered = filteredProtocolsData.filter((item) =>
                  activeProto.includes(item.DetectionTypeId)
                );
              }

              console.log('filteredAndIntrusionFiltered length:', filteredAndIntrusionFiltered.length)
              if (filteredAndIntrusionFiltered.length > 0) {
                console.log('data exists:', true)
                setAssignedProtocols(filteredAndIntrusionFiltered)
                setDeviceDataExist(true)
              } else {
                console.log('data exists1:', false)
                protocolsListing();
              }

            } else {
              console.log('data exists2:', false)
              protocolsListing();
            }
          }
          else {
            console.log('data exists3:', false)
            protocolsListing();
          }
        }
      })
    }
  }

  const protocolsListing = () => {
    setAssignedProtocols([])
    setDeviceDataExist(false);

    if (activeProto.length > 0) {
      if (protocolList.length > 0) {
        const IntrusionInfo = protocolList.filter(item => activeProto.includes(item.Id))
        if (IntrusionInfo.length > 0) {
          setAssignedProtocols(IntrusionInfo)
          console.log('IntrusionInfo :', JSON.stringify(IntrusionInfo))
          return
        }
      }
    }
  }



  // useEffect(() => {
  //     console.log(assignedProtocols)
  //       if(assignedProtocols.length === 0){
  //         setMessage1('');
  //         setMessage2('');
  //         setMessage3('');
  //       }
  //       else{
  //         if(assignedProtocols.length=== 1 && !deviceDataExist){
  //                 setMessage1(assignedProtocols[0].Message1?assignedProtocols[0].Message1:assignedProtocols[0]);
  //                 setMessage2(assignedProtocols[0].Message2?assignedProtocols[0].Message2:assignedProtocols[1]);
  //                 setMessage3(assignedProtocols[0].Message3?assignedProtocols[0].Message3:assignedProtocols[2]);
  //         }
  //         else if(assignedProtocols.length > 1 && !deviceDataExist){
  //           assignedProtocols[0] ? setMessage1(assignedProtocols[0]) : setMessage1('')
  //           assignedProtocols[1] ? setMessage2(assignedProtocols[1]) : setMessage2('')
  //           assignedProtocols[2] ? setMessage3(assignedProtocols[2]) : setMessage3('')
  //         }
  //      }
  //   },[assignedProtocols])


  useEffect(() => {
    ////console.log('clientInfo--------',clientInfo)
    // setFianlClientData([]);

    ProtocolDetails(0, 'updatevalues');

    if (clientInfo.length == 1) {
      ////console.log("clientInfo Length" ,clientInfo)
      if (clientInfo[0].PoliceNo !== null) {
        setPoliceNo(clientInfo[0].PoliceNo)
      }
      else {
        setPoliceNo('')
      }

      if (clientInfo[0].MobileNo !== null) {
        setMobileNo(clientInfo[0].MobileNo)
      }
      else {
        setMobileNo('')
      }
      // setAddress(clientInfo[0].Address)
      if (clientInfo[0].FireNo !== null) {
        setFireNo(clientInfo[0].FireNo)

      }
      else {
        setFireNo('')
      }

      if (clientInfo[0].Email !== null) {
        setEmail(clientInfo[0].Email)
      }
      else {
        setEmail('')
      }
      if (clientInfo[0].Address !== null) {
        setAddress(clientInfo[0].Address)
      }
      else {
        setAddress('')

      }

      setPrimarySpocContact(clientInfo[0].primary_spoc_contact ?? '')
      setSecondaryPocContact(clientInfo[0].secondary_poc_contact ?? '')
      setOnsiteMaintenanceSupportContact(clientInfo[0].onsite_maintenance_support_contact ?? '')
      setOnsiteSpeakerTestingSpoc(clientInfo[0].onsite_speaker_testing_spoc ?? '')
      setLocalNonEmergencyContact(clientInfo[0].local_non_emergency_contact ?? '')
      setFireDepartmentContact(clientInfo[0].fire_department_contact ?? '')
      setSecurityPatrolContact(clientInfo[0].security_patrol_contact ?? '')
    }
    else {
      // setFianlClientData([]);

      setPoliceNo('')
      setMobileNo('')
      setAddress('')
      setFireNo('')
      setEmail('')
      setPrimarySpocContact('')
      setSecondaryPocContact('')
      setOnsiteMaintenanceSupportContact('')
      setOnsiteSpeakerTestingSpoc('')
      setLocalNonEmergencyContact('')
      setFireDepartmentContact('')
      setSecurityPatrolContact('')
      setInputValue('');
    }

  }, [clientInfo])

  //const [clientSelected,setClientSelected]=useState(false)
  const handleClient = (_, value) => {
    // console.log("===============================client dropdown==============",value);
    setActiveCameras([])
    setCheckValue(false)
    setGroupCamersInfo([])
    setActiveProto([])
    setCheckProtoValue(false)
    setSelectedGroupOption(null)
    setClientLocationOptions([])
    setSelectedClientLocations([])
    setLocationCheckValue(false)
    setOpenAuto(false)

    if (!value) {
      selectedClientName([]);
      setCamSelectedItems([]);
      setCamsList([]);
      setPoliceNo('')
      setMobileNo('')
      setAddress('')
      setFireNo('')
      setEmail('')
      setPrimarySpocContact('')
      setSecondaryPocContact('')
      setOnsiteMaintenanceSupportContact('')
      setOnsiteSpeakerTestingSpoc('')
      setLocalNonEmergencyContact('')
      setFireDepartmentContact('')
      setSecurityPatrolContact('')
      setIsClientSelected(false);
      setSaveError(false);
      setClientGroups([])
      setSelectedProtocol([]);
      setGroupList([])
      setAssignedProtocols([])
      //setSelectedProto([]);
      //setList([])
    } else {
      //setList([])

      setDeviceDataExist(false);
      setCamSelectedItems([]);
      selectedClientName(value);
      setIsClientSelected(true);
      setLastEmail(false)
      setLastFireNumber(false)
      setLastNumber(false)
      setLastContact(false)
      setLastPrimarySpoc(false)
      setLastSecondaryPoc(false)
      setLastOnsiteMaintenance(false)
      setLastOnsiteSpeakerTesting(false)
      setLastLocalNonEmergency(false)
      setLastFireDepartment(false)
      setLastSecurityPatrol(false)
      setSelectedProtocol([]);
      setGroupList([])
      setCamsList([])
      setAssignedProtocols([])
      // if(groups.length>0){
      //   setGroupList(groups)
      // }
      // else{
      //   setGroupList([])
      // }


      //console.log(groups)

    }
  };

  const [openAuto, setOpenAuto] = useState(false)

  const handleLocationFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);
    return options.length > 0 ? [{ title: 'Select All', selectall: true }, ...filtered] : filtered;
  };

  const handleLocationChange = (event, value) => {
    let nextSelectedLocations = [];

    if (value.some((obj) => obj.hasOwnProperty('selectall'))) {
      nextSelectedLocations = locationCheckValue
        ? []
        : clientLocationOptions.map((locationItem) => locationItem.ID || locationItem.id);
    } else {
      nextSelectedLocations = value.map((locationItem) => locationItem.ID || locationItem.id);
    }

    setSelectedClientLocations(nextSelectedLocations);
    setLocationCheckValue(
      clientLocationOptions.length > 0 && nextSelectedLocations.length === clientLocationOptions.length
    );
    setActiveCameras([]);
    setCheckValue(false);
    setOpenAuto(false);
    setActiveProto([]);
    setCheckProtoValue(false);
    setAssignedProtocols([]);
    setSelectedGroupOption(null);
    setGroupList([]);
    setGroupCamersInfo([]);
    setCamsList([]);

    if (nextSelectedLocations.length === 0) {
      return;
    }

    loadGroupsForSelection(clientName?.ID, nextSelectedLocations);
  };

  const handleCamera = (event, value) => {
    let actCams = [];
    if (value.some(obj => obj.hasOwnProperty('selectall'))) {
      if (activeCameras.length === selectedCamesList.length) {
        setActiveCameras([])
        setCheckValue(false)
      }
      else {
        selectedCamesList.forEach(item => {
          actCams.push(item.deviceid)
        })
        setActiveCameras(actCams)
        setCheckValue(true)
      }
    }
    else {
      let id = value[0].deviceid;
      if (activeCameras.includes(id)) {
        let filterArr = activeCameras.filter(divid => divid !== id);

        if (filterArr.length === 0) {
          setAssignedProtocols([])  // updated on 2024-10-29
        }
        setActiveCameras(filterArr);
        if (checkValue) {
          setCheckValue(false)
        }
      }
      else {
        setActiveCameras((prv) => [...prv, id])
      }
    }
  }

  useEffect(() => {
    if (activeCameras.length === selectedCamesList.length && activeCameras.length > 0) {
      setCheckValue(true)
    }

    if (activeCameras.length > 0) {
      setClientAvail(true)
    }
    else {
      setClientAvail(false)
    }
  }, [activeCameras])


  const handleOpen = () => {
    setIsExisted(false)
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setNewProtoName('');
    setProtocolNameError(false);
  };

  const [isExisted, setIsExisted] = useState(false)

  useEffect(() => {
    setMessageErrors({})
    if (activeProto.length === protocolList.length && activeProto.length > 0) {
      setCheckProtoValue(true)
    }
  }, [activeProto])

  const handleProtocol = (event, value) => {
    let actProto = [];
    if (value.some(obj => obj.hasOwnProperty('selectall'))) {
      if (activeProto.length === protocolList.length) {
        setActiveProto([])
        setCheckProtoValue(false)
        setSelectedProtocol([]);
        setAssignedProtocols([]);
        setDeviceDataExist(false)
        setProtocolInfo('')
      }
      else {
        protocolList.forEach(item => {
          actProto.push(item.Id)
        })
        setActiveProto(actProto)
        setCheckProtoValue(true)
      }
    }
    else {
      let id = value[0].Id;
      if (activeProto.includes(id)) {
        let filterArr = activeProto.filter(val => val !== id);

        setActiveProto(filterArr);
        if (checkProtoValue) {
          setCheckProtoValue(false)
        }
      }
      else {
        setActiveProto((prv) => [...prv, id])
      }
    }
  }

  // complete Protocol Save 

  const handleProtocolSave = () => {
    // if(!clientTypeerror){
    //   setClientTypeError(true); // Set save error if client is not selected
    //   return;
    // }

    if (!isClientSelected) {
      setSaveError(true); // Set save error if client is not selected
      return;
    }

    // //console.log('Email',email);
    const data = {
      ClientId: clientName.ID,
      PoliceNo: policeno,
      FireNo: fireNo,
      Address: address,
      Email: email,
      MobileNo: mobileno,
      primary_spoc_contact: primarySpocContact,
      secondary_poc_contact: secondaryPocContact,
      onsite_maintenance_support_contact: onsiteMaintenanceSupportContact,
      onsite_speaker_testing_spoc: onsiteSpeakerTestingSpoc,
      local_non_emergency_contact: localNonEmergencyContact,
      fire_department_contact: fireDepartmentContact,
      security_patrol_contact: securityPatrolContact
    };

    Object.keys(data).forEach(key => data[key] = typeof data[key] === 'string' && data[key].endsWith(',') ? data[key].slice(0, -1) : data[key]);

    // console.log(data)

    setSaveProtocol(data, (response) => {
      if (response.status === 200) {
        ////console.log('Protocol Name:',response);

        setPoliceNo('')
        setMobileNo('')
        setAddress('')
        setFireNo('')
        setEmail('')
        setPrimarySpocContact('')
        setSecondaryPocContact('')
        setOnsiteMaintenanceSupportContact('')
        setOnsiteSpeakerTestingSpoc('')
        setLocalNonEmergencyContact('')
        setFireDepartmentContact('')
        setSecurityPatrolContact('')

        if (clientName.ID !== undefined && clientName.ID !== null) {
          getClientInfo(clientName.ID, (response) => {
            if (response.status === 200) {
              if (response.data !== null) {
                setClientDetails(response.data);
                setShowMessage(true)
                setTimeout(() => {
                  setShowMessage(false);
                }, 3000);
              }
            }
          })
        }
      }
    })


  }


  // Handle protocol message Save
  const handleProtocolMessageSave = () => {
    const deviceIds = selectedCamItems.map(item => item.deviceid);

    if (activeCameras.length !== 0) {

      const data = {
        DeviceId: activeCameras.map(item => `${item}`).join(','),
        DetectionTypeId: activeProto.join(',')
      }

      console.log('data:', JSON.stringify(data));

      addUpdateProtocolActions(data, (response) => {
        ////console.log(response)
        if (response.status === 200) {
          setHeader('')
          setErrorCams('Protocols Added Successfully')
          setOpenError(true)
          setDeviceDataExist(true)
          HandleProtocolInfo()
          setProtocolInfo('')
          setSelectedProtocol([])
          setActiveProto([])
        }
      })
      // setMultiDevicesProtocol(data,(response)=>{
      //   if(response.status === 200){
      //     // need to show alert box

      //     setHeader('')
      //     setErrorCams('Protocols Added Successfully')
      //     setOpenError(true)

      //     HandleProtocolInfo()

      //   }})
    }
    else {

      const body = {
        IntrusionId: activeProto.join(','),
        Message1: message1,
        Message2: message2,
        Message3: message3
      }

      if (message1 === null || message1 === '') delete body.Message1; if (message2 === null || message2 === '') delete body.Message2; if (message3 === null || message3 === '') delete body.Message3;

      if (Object.keys(body).length) {
        updateProtocolActions(body, (response) => {
          if (response.status === 200) {
            setOpenError(true)
            setHeader('Protocol Message Added Successfully!!')
            setErrorCams('')
            HandleProtocolInfo()
          }

        })
      }
    }
  }


  const [newText, setNewText] = useState('')
  const addProtocolMessage = (values, deviceId) => {

    let body = [{
      "DeviceId": parseInt(deviceId),
      "IntrusionId": selectedProto.IntrusionId,
      "Message": newText
    }]

    setMultiDevicesProtocol(body, (response) => {
      if (response.status === 200) {
        HandleProtocolInfo();
        ////console.log(newMessage)
        setNewMessage(newMessage.filter(item => item.sno !== values))
        setNewText('');
      }
    })
  }

  const textFieldRefs = useRef([]);

  const [editable, setEditable] = useState({})

  const [indexVal, setIndexVal] = useState(null)
  const [deviceVal, setDeviceVal] = useState(0)

  //const [originalData, setOriginalData] = useState({});


  const handleEdit = (row, index, deviceid, intrusionType) => {
    const key = `${deviceid}_${index}_${intrusionType}`;
    const ind = assignedProtocols.findIndex(item => item.Id === row.Id);
    if (ind !== -1) {
      // console.log(assignedProtocols[ind])
      setOriginalDataNew(assignedProtocols[ind]);
    }

    setEditable((prev) => ({
      ...prev,
      [key]: true
    }))
  };

  const HandleProtocolInfo = () => {
    const protocolParams = {
      mapped_action_id: 0
    };

    getClientProtocolsInfoActions(protocolParams, (response) => {
      if (response.status === 200) {
        const protocolsInfo = trimProtocolData(response.data)
        setAssignedProtocols(protocolsInfo)
      }
    })
  }

  const deleteProtoMessage = () => {
    deleteMessage(protoData, (response) => {
      if (response.status === 200) {
        // rendering 
        handleCloseError()
        setprotoData({})
        setShowConfirm(false)
        HandleProtocolInfo()
      }
    })
  }

  const [protoData, setprotoData] = useState({})

  // Define handleRemove function
  const handleRemove = (index, key) => {
    const data = {
      Id: key
    }
    setprotoData(data)
    setShowConfirm(true)
    setOpenError(true)
    setHeader('Do You Want to Delete Protocol Message?')
    setErrorCams('')

  };

  const handleSaveData = () => {
    if (removeData) {

      // console.log(removeData)

      const data = removeData[0]
      const key = removeData[2]

      // if(data.hasOwnProperty(key)){
      //   data[key] = "";

      // let body = {DeviceId:row.DeviceId.toString(),IntrusionId:row.IntrusionId}
      //  DeleteDeviceMapping(body,(response)=>{
      //   //console.log(response)
      //   if(response.status === 200){
      //     HandleProtocolInfo()
      //     setRemoveData([])
      //     setDelProto(false)
      //   }
      // })
      // }

      const hasValuesAtIndices = removeData.slice(0, 3).every(value => value !== null && value !== undefined && value !== "");
      if (hasValuesAtIndices) {
        const [row, index, messageId] = removeData;
        handleSave(row, index, messageId, "")
      }


    }
  }

  useEffect(() => {
    // console.log(messageErrors)
  }, [messageErrors])

  // Define handleSave function
  const handleSave = (row, index, messageId, type, intrusionType) => {
    // setMessageErrors(prev => {
    //   const newErrors = { ...prev };
    //   newErrors[`${row.DeviceId}_${index},${intrusionType}`] = "";
    //   return newErrors;
    // });
    let hasError = false
    setDelProto(false)
    if (!messageId) {
      let allMessagesContainValues = []

      if (!row.data) {
        const messageKeys = Object.keys(row).filter(key => key.startsWith("Message"));
        allMessagesContainValues = [row.Message1, row.Message2, row.Message3].every(msg => msg !== null && msg.trim() !== "");

        //const keyToCheck =allMessagesContainValues ? messageKeys[index-1] :  messageKeys[index];
        const keyToCheck = messageKeys[index - 1];

        const isNullValue = row[keyToCheck] === null || row[keyToCheck] === "" || row[keyToCheck] === "null";
        // console.log(isNullValue)

        if (isNullValue) {
          setMessageErrors(prev => ({
            ...prev,
            [`${row.DeviceId}_${index}_${intrusionType}`]: "This field is required"
          }));
          hasError = true;
        }
      }
      else {
        if (activeProto.length > 0) {
          // console.log(intrusionType)
          let typeVal = '', ix = 0;
          if (!intrusionType) {
            // console.log(activeProto)
            // console.log(protocolList)
            typeVal = protocolList.filter(val => activeProto.includes(val.Id))[0].IntrusionType
            const nonEmptyMessageCount = Object.entries(assignedProtocols[0])
              .filter(([key, value]) => key.startsWith("Message") && value && value.trim() !== "").length;
            ix = nonEmptyMessageCount + 1;
          }
          const messageKeys = Object.keys(row.data).filter(key => key.startsWith("Message"));
          const key = messageKeys[(row.sno - 1)]
          const isNullValue = row.data[key] === null || row.data[key] === "" || row.data[key] === "null";
          // console.log(newText)
          if (isNullValue && !newText) {
            setMessageErrors(prev => ({
              ...prev,
              [`${row.data.DeviceId}_${index}_${typeVal}`]: "This field is required"
            }));
            hasError = true;
          }
        }
        // else if(activeProto.length>1){
        //   //console.log(intrus)
        //   const val = groupMessagesByDeviceId(assignedProtocols)
        //   console.log(val)
        //   return
        // }
      }
      // if(index >= 0 ){
      //   let allMessagesContainValues =[]

      //   if(!row.data){
      //     allMessagesContainValues = [row.Message1, row.Message2, row.Message3].every(msg => msg !== null && msg.trim() !== "");

      //     const keyToCheck =allMessagesContainValues ? messageKeys[index-1] :  messageKeys[index];
      //     const isNullValue = row[keyToCheck] === null || row[keyToCheck] === "" || row[keyToCheck] === "null";
      //     console.log(isNullValue)

      //     if (isNullValue) {
      //       setMessageErrors(prev => ({
      //         ...prev,
      //         [`${row.DeviceId}_${index}`]: "This field is required"
      //       }));
      //       hasError = true;
      //       // messageKeys.forEach((key, idx) => {
      //       //   if (!row[key] || row[key] === "null") {
      //       //     setMessageErrors(prev => ({
      //       //       ...prev,
      //       //       [`${row.DeviceId}_${index}`]: "This field is required"
      //       //     }));
      //       //     hasError = true;
      //       //   }
      //       // });
      //     }
      //   }
      // }


    }

    if (hasError) {
      // setHeader('')
      // setOpenError(true)
      // setErrorCams('Please add Protocol Messages')
      return;
    }

    let text = ""; let callRemove = false;
    if (type === 'addNew') {
      row = row.data
      //console.log(row)
      if (key && newText) {
        row[key] = newText
        setNewText('')
      }

      else {
        setHeader('Enter Protocol Message')
        return;
      }
      setNewMessage([])
    }
    if (messageId) {
      //console.log(row)
      //console.log(row[messageId])
      row[messageId] = '';
      //text = "Protocol Message Removed Successfully!!";    
      let MessageCount = Object.keys(row).filter(key => key.startsWith('Message') && row[key] !== "").length;
      if (MessageCount === 0) {
        callRemove = true // to track if all messages are deleted 
      }
    }
    else {
      text = "Protocol Message Updated Successfully!!";
    }

    if (callRemove) {
      let body = { DeviceId: row.DeviceId.toString(), IntrusionId: row.IntrusionId }
      DeleteDeviceMapping(body, (response) => {
        //console.log(response)
        if (response.status === 200) {
          HandleProtocolInfo()
          setRemoveData([])
          setDelProto(false)
        }
      })
    }
    else {

      let body = {};
      body = { IntrusionId: row.IntrusionId, DeviceId: row.DeviceId, Message1: row.Message1, Message2: row.Message2, Message3: row.Message3, Message4: row.Message4, Message5: row.Message5 }

      // if(type !== 'addNew'){
      //   body={IntrusionId:row.IntrusionId,DeviceId:row.DeviceId,Message1:row.Message1,Message2:row.Message2,Message3:row.Message3}
      // }
      // else {
      //   body={IntrusionId:row.IntrusionId,DeviceId:row.DeviceId,Message1:row.Message1,Message2:row.Message2,Message3:row.Message3,Message4:row.Message4,Message5:row.Message5}
      // }

      UpdateMessage(body, (response) => {
        //console.log(response)
        if (response.status === 200) {
          setEditable((prev) => ({
            ...prev,
            [`${row.DeviceId}_${index}_${intrusionType}`]: false,
          }));
          if (text) {
            setOpenError(true)
            setHeader(text)
          }
          setErrorCams('')
          HandleProtocolInfo();
          setAddMessage(false)
          setMessageErrors({})
        }
      })

    }

  };

  const [newMessage, setNewMessage] = useState([])
  const [key, setKey] = useState('')




  const groupMessagesByDeviceId = (messages) => {
    const groupedMessages = {};
    assignedProtocols.forEach(message => {
      if (!groupedMessages[message.DeviceId]) {
        groupedMessages[message.DeviceId] = [];
      }
      groupedMessages[message.DeviceId].push(message);
    });
    return groupedMessages;
  }

  useEffect(() => {
    // console.log(editable)
  }, [editable])



  const handleInputChange = (row, value, deviceId, text, messageType) => {
    if (text === 'editable') {

      // let updatedIntrosionMessages = [...assignedProtocols]; 
      // updatedIntrosionMessages = updatedIntrosionMessages.filter(item => item.Id === row.Id)
      // updatedIntrosionMessages[0][messageType] = value;

      setAssignedProtocols(prevData =>
        prevData.map(item => {
          if (item.Id === row.Id) {
            return {
              ...item,
              [messageType]: value === '' ? 'null' : value
            };
          }
          return item;
        })
      );


      //if (index !== -1) {
      //  const updatedIntrosionMessages = [...assignedProtocols]; 
      //  //console.log(updatedIntrosionMessages[1][messageType])
      // // updatedIntrosionMessages[index][messageType] = value; 
      // // setAssignedProtocols(updatedIntrosionMessages); 
      //}
    }

  };

  const [lastNumber, setLastNumber] = useState(false)
  const [lastFireNumber, setLastFireNumber] = useState(false)
  const [lastEmail, setLastEmail] = useState(false)
  const [lastContact, setLastContact] = useState(false)
  const [lastPrimarySpoc, setLastPrimarySpoc] = useState(false)
  const [lastSecondaryPoc, setLastSecondaryPoc] = useState(false)
  const [lastOnsiteMaintenance, setLastOnsiteMaintenance] = useState(false)
  const [lastOnsiteSpeakerTesting, setLastOnsiteSpeakerTesting] = useState(false)
  const [lastLocalNonEmergency, setLastLocalNonEmergency] = useState(false)
  const [lastFireDepartment, setLastFireDepartment] = useState(false)
  const [lastSecurityPatrol, setLastSecurityPatrol] = useState(false)



  const removeNumber = (e, index, type) => {
    e.stopPropagation()
    if (type === 'policeNumber') {
      const numbersArray = policeno.split(',');
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(',');
      if (updatedNumbers) {
        setPoliceNo(updatedNumbers);
      }
      else {
        setPoliceNo('');
        setLastNumber(true)
      }

    }
    else if (type === 'fireNo') {
      const numbersArray = fireNo.split(',');
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(',');
      if (updatedNumbers)
        setFireNo(updatedNumbers);
      else {
        setFireNo('')
        setLastFireNumber(true)
      }
    }
    else if (type === 'email') {
      const numbersArray = email.split(',');
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(',');
      if (updatedNumbers) {
        setEmail(updatedNumbers);
      }
      else {
        setEmail('')
        setLastEmail(true)
      }

    }
    else if (type === 'mobile') {
      const numbersArray = mobileno.split(',');
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(',');
      if (updatedNumbers) {
        setMobileNo(updatedNumbers);
      }
      else {
        setMobileNo('')
        setLastContact('')
      }
    }
    else if (type === 'primarySpocContact') {
      const numbersArray = primarySpocContact.split(',');
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(',');
      if (updatedNumbers) {
        setPrimarySpocContact(updatedNumbers);
      } else {
        setPrimarySpocContact('');
        setLastPrimarySpoc(true);
      }
    }
    else if (type === 'secondaryPocContact') {
      const numbersArray = secondaryPocContact.split(',');
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(',');
      if (updatedNumbers) {
        setSecondaryPocContact(updatedNumbers);
      } else {
        setSecondaryPocContact('');
        setLastSecondaryPoc(true);
      }
    }
    else if (type === 'onsiteMaintenanceSupportContact') {
      const numbersArray = onsiteMaintenanceSupportContact.split(',');
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(',');
      if (updatedNumbers) {
        setOnsiteMaintenanceSupportContact(updatedNumbers);
      } else {
        setOnsiteMaintenanceSupportContact('');
        setLastOnsiteMaintenance(true);
      }
    }
    else if (type === 'onsiteSpeakerTestingSpoc') {
      const numbersArray = onsiteSpeakerTestingSpoc.split(',');
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(',');
      if (updatedNumbers) {
        setOnsiteSpeakerTestingSpoc(updatedNumbers);
      } else {
        setOnsiteSpeakerTestingSpoc('');
        setLastOnsiteSpeakerTesting(true);
      }
    }
    else if (type === 'localNonEmergencyContact') {
      const numbersArray = localNonEmergencyContact.split(',');
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(',');
      if (updatedNumbers) {
        setLocalNonEmergencyContact(updatedNumbers);
      } else {
        setLocalNonEmergencyContact('');
        setLastLocalNonEmergency(true);
      }
    }
    else if (type === 'fireDepartmentContact') {
      const numbersArray = fireDepartmentContact.split(',');
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(',');
      if (updatedNumbers) {
        setFireDepartmentContact(updatedNumbers);
      } else {
        setFireDepartmentContact('');
        setLastFireDepartment(true);
      }
    }
    else if (type === 'securityPatrolContact') {
      const numbersArray = securityPatrolContact.split(',');
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(',');
      if (updatedNumbers) {
        setSecurityPatrolContact(updatedNumbers);
      } else {
        setSecurityPatrolContact('');
        setLastSecurityPatrol(true);
      }
    }
  };

  const [addEmptyBox, setEmptyBox] = useState([
    {
      police: false,
      fire: false,
      email: false,
      contact: false,
      primarySpoc: false,
      secondaryPoc: false,
      onsiteMaintenance: false,
      onsiteSpeakerTesting: false,
      localNonEmergency: false,
      fireDepartment: false,
      securityPatrol: false
    }
  ])

  const handleBoxClick = (val) => {
    // console.log("mobileno",val);

    if (val === 'policeno') {
      // console.log("policeNo",policeno);
      if (policeno) {
        setPoliceNo(policeno + ',')
      }
      else {
        setEmptyBox(prevState => [
          {
            ...prevState[0],
            police: true
          },
          ...prevState.slice(1)
        ]);
        if (lastNumber) {
          setLastNumber(false)
        }
      }
    }
    else if (val === 'fireno') {
      //setFireNo(fireNo + ',');
      if (fireNo) {
        setFireNo(fireNo + ',')
      }
      else {
        setEmptyBox(prevState => [
          {
            ...prevState[0],
            fire: true
          },
          ...prevState.slice(1)
        ]);
        if (lastFireNumber) {
          setLastFireNumber(false)
        }
      }
    }
    else if (val === 'email') {
      //setEmail(email + ',')
      if (email) {
        setEmail(email + ',')
      }
      else {
        setEmptyBox(prevState => [
          {
            ...prevState[0],
            email: true
          },
          ...prevState.slice(1)
        ]);
        if (lastEmail) {
          setLastEmail(false)
        }
      }
    }
    else if (val === 'mobileno') {
      // setMobileNo(mobileno + ',')
      if (mobileno) {
        setMobileNo(mobileno + ',')
      }
      else {
        setEmptyBox(prevState => [
          {
            ...prevState[0],
            contact: true
          },
          ...prevState.slice(1)
        ]);
        if (lastContact) {
          setLastContact(false)
        }
      }
    }
    else if (val === 'primarySpocContact') {
      if (primarySpocContact) {
        setPrimarySpocContact(primarySpocContact + ',')
      }
      else {
        setEmptyBox(prevState => [
          {
            ...prevState[0],
            primarySpoc: true
          },
          ...prevState.slice(1)
        ]);
        if (lastPrimarySpoc) {
          setLastPrimarySpoc(false)
        }
      }
    }
    else if (val === 'secondaryPocContact') {
      if (secondaryPocContact) {
        setSecondaryPocContact(secondaryPocContact + ',')
      }
      else {
        setEmptyBox(prevState => [
          {
            ...prevState[0],
            secondaryPoc: true
          },
          ...prevState.slice(1)
        ]);
        if (lastSecondaryPoc) {
          setLastSecondaryPoc(false)
        }
      }
    }
    else if (val === 'onsiteMaintenanceSupportContact') {
      if (onsiteMaintenanceSupportContact) {
        setOnsiteMaintenanceSupportContact(onsiteMaintenanceSupportContact + ',')
      }
      else {
        setEmptyBox(prevState => [
          {
            ...prevState[0],
            onsiteMaintenance: true
          },
          ...prevState.slice(1)
        ]);
        if (lastOnsiteMaintenance) {
          setLastOnsiteMaintenance(false)
        }
      }
    }
    else if (val === 'onsiteSpeakerTestingSpoc') {
      if (onsiteSpeakerTestingSpoc) {
        setOnsiteSpeakerTestingSpoc(onsiteSpeakerTestingSpoc + ',')
      }
      else {
        setEmptyBox(prevState => [
          {
            ...prevState[0],
            onsiteSpeakerTesting: true
          },
          ...prevState.slice(1)
        ]);
        if (lastOnsiteSpeakerTesting) {
          setLastOnsiteSpeakerTesting(false)
        }
      }
    }
    else if (val === 'localNonEmergencyContact') {
      if (localNonEmergencyContact) {
        setLocalNonEmergencyContact(localNonEmergencyContact + ',')
      }
      else {
        setEmptyBox(prevState => [
          {
            ...prevState[0],
            localNonEmergency: true
          },
          ...prevState.slice(1)
        ]);
        if (lastLocalNonEmergency) {
          setLastLocalNonEmergency(false)
        }
      }
    }
    else if (val === 'fireDepartmentContact') {
      if (fireDepartmentContact) {
        setFireDepartmentContact(fireDepartmentContact + ',')
      }
      else {
        setEmptyBox(prevState => [
          {
            ...prevState[0],
            fireDepartment: true
          },
          ...prevState.slice(1)
        ]);
        if (lastFireDepartment) {
          setLastFireDepartment(false)
        }
      }
    }
    else if (val === 'securityPatrolContact') {
      if (securityPatrolContact) {
        setSecurityPatrolContact(securityPatrolContact + ',')
      }
      else {
        setEmptyBox(prevState => [
          {
            ...prevState[0],
            securityPatrol: true
          },
          ...prevState.slice(1)
        ]);
        if (lastSecurityPatrol) {
          setLastSecurityPatrol(false)
        }
      }
    }
  }
  const [newIndex, setNewIndex] = useState(-1);

  const handleNumberChange = (event, index, type) => {
    if (type === 'police') {
      const numbersArray = policeno.split(',');
      numbersArray[index] = event.target.value;
      const updatedNumbers = numbersArray.join(',');
      setPoliceNo(updatedNumbers);
    }
    else if (type === 'fire') {
      const numbersArray = fireNo.split(',');
      numbersArray[index] = event.target.value;
      const updatedNumbers = numbersArray.join(',');
      setFireNo(updatedNumbers);
    }
    else if (type === 'email') {
      const numbersArray = email.split(',');
      numbersArray[index] = event.target.value;
      const updatedNumbers = numbersArray.join(',');
      setEmail(updatedNumbers);
    }
    else if (type === 'mobile') {
      const numbersArray = mobileno.split(',');
      numbersArray[index] = event.target.value;
      const updatedNumbers = numbersArray.join(',');
      setMobileNo(updatedNumbers);
    }
    else if (type === 'primarySpocContact') {
      const numbersArray = primarySpocContact.split(',');
      numbersArray[index] = event.target.value;
      setPrimarySpocContact(numbersArray.join(','));
    }
    else if (type === 'secondaryPocContact') {
      const numbersArray = secondaryPocContact.split(',');
      numbersArray[index] = event.target.value;
      setSecondaryPocContact(numbersArray.join(','));
    }
    else if (type === 'onsiteMaintenanceSupportContact') {
      const numbersArray = onsiteMaintenanceSupportContact.split(',');
      numbersArray[index] = event.target.value;
      setOnsiteMaintenanceSupportContact(numbersArray.join(','));
    }
    else if (type === 'onsiteSpeakerTestingSpoc') {
      const numbersArray = onsiteSpeakerTestingSpoc.split(',');
      numbersArray[index] = event.target.value;
      setOnsiteSpeakerTestingSpoc(numbersArray.join(','));
    }
    else if (type === 'localNonEmergencyContact') {
      const numbersArray = localNonEmergencyContact.split(',');
      numbersArray[index] = event.target.value;
      setLocalNonEmergencyContact(numbersArray.join(','));
    }
    else if (type === 'fireDepartmentContact') {
      const numbersArray = fireDepartmentContact.split(',');
      numbersArray[index] = event.target.value;
      setFireDepartmentContact(numbersArray.join(','));
    }
    else if (type === 'securityPatrolContact') {
      const numbersArray = securityPatrolContact.split(',');
      numbersArray[index] = event.target.value;
      setSecurityPatrolContact(numbersArray.join(','));
    }
  };

  const renderMultiValueField = ({
    label,
    value,
    lastValueRemoved,
    clickKey,
    changeType,
    removeType,
    placeholder,
    md = 3,
  }) => (
    <Grid item xs={12} sm={6} lg={md}>
      <InputLabel shrink>
        {label}
      </InputLabel>
      <Box
        sx={{
          border: (theme) => `1px solid ${theme.palette.divider}`,
          padding: '8px',
          borderRadius: '8px',
          minHeight: isClientSelected && clientInfo.length == 1 && value && !lastValueRemoved ? 'auto' : '50px',
        }}
        onClick={() => handleBoxClick(clickKey)}
      >
        {!lastValueRemoved && isClientSelected && String(value || '').split(',').map((itemValue, index) => (
          <Box
            key={`${clickKey}-${index}`}
            sx={{
              marginBottom: 1,
              width: '80%',
              backgroundColor: (theme) => theme.palette.action.selected,
              borderRadius: '100px',
              border: 'none',
              position: 'relative',
            }}
          >
            <TextField
              placeholder={placeholder}
              value={itemValue}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => handleNumberChange(e, index, changeType)}
              fullWidth
              size="small"
              sx={{
                '& input': {
                  height: '14px',
                  fontSize: '14px',
                  color: (theme) => theme.palette.text.primary,
                  "&::placeholder": {
                    color: (theme) => theme.palette.text.secondary,
                    opacity: 1,
                  },
                },
                '& fieldset': {
                  borderRadius: 50,
                  border: 'none'
                }
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                right: '8px',
                transform: 'translateY(-50%)',
                width: '15px',
                height: '15px',
                borderRadius: '50%',
                backgroundColor: (theme) => theme.palette.action.selected,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <IconButton
                sx={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-8px',
                }}
                onClick={(e) => removeNumber(e, index, removeType)}
              >
                <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
              </IconButton>
            </Box>
          </Box>
        ))}
      </Box>
    </Grid>
  );

  const handleFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);

    // Separate selected and unselected options
    const selectedOptions = filtered.filter(option => activeCameras.includes(option.deviceid));
    const unselectedOptions = filtered.filter(option => !activeCameras.includes(option.deviceid));

    // Sort options: selected options first, then unselected
    const sortedOptions = [...selectedOptions, ...unselectedOptions];

    return [{ title: 'Select All', selectall: true }, ...filtered];
  };

  const [value, setValue] = useState('one');
  const handleChange = (event, newValue) => {
    setErrors({})
    setIndexHist(null)
    setItemSelectedId(null)

    if (newValue === 'one') {
      setActiveProto([])
      setCheckProtoValue(false)
      setProtocolInfo('')
      setMessageErrors({})
      setEditable({})
      setAddProtocol(true)
      setAssignProtocol(false)
      if (deviceDataExist) {
        setDeviceDataExist(false)
      }
      setClientType('')
      setAssignedProtocols([])
      setActiveCameras([])
      setSelectedProtocol([])
      setGroupList([])
      setPoliceNo('')
      setMobileNo('')
      setEmail('')
      setAddress('')
      setFireNo('')
      setPrimarySpocContact('')
      setSecondaryPocContact('')
      setOnsiteMaintenanceSupportContact('')
      setOnsiteSpeakerTestingSpoc('')
      setLocalNonEmergencyContact('')
      setFireDepartmentContact('')
      setSecurityPatrolContact('')
      setCamsList([])
      setCheckValue(false)
      ProtocolDetails(0)
    }
    else if (newValue === 'two') {
      setData([])
      setAddProtocol(false)
      setAssignProtocol(true)
      const initialFormDetails = {
        introsionType: '',
        incidentType: '',
        messageOne: '',
        messageTwo: '',
        messageThree: ''
      };
      setFormDetails(initialFormDetails);
      //setData([])
      // console.log(data)

    }
    setValue(newValue);
  };

  useEffect(() => {

    // //console.log(assignedProtocols)
    if (value === 'one') {
      setAddProtocol(true)
      setAssignProtocol(false)
      //setAssignedProtocols([])
    }
  }, [])


  const initialProtocolValues = {
    detectionType: '',
    action1: '',
    action2: '',
    action3: '',
    action4: '',
    exception: ''
  }

  const [formDetails, setFormDetails] = useState(initialProtocolValues)

  const clearValues = () => {
    setFormDetails(initialProtocolValues)

    setErrors({})
  }


  const [originalData, setOriginalData] = useState([])

  const [errors, setErrors] = useState({});

  const handleFormChange = (event, type) => {

    if (type) {
      setFormDetails((prv) => ({
        ...prv,
        [type]: event.target.value
      }))

      setErrors(prevErrors => ({
        ...prevErrors,
        [type]: ''
      }));
    }
  }

  const ProtocolDetails = (id, text) => {
    getProtocolInfoActions(id, (response) => {
      if (response.status === 200) {
        const protocolsData = trimProtocolData(response.data)
        setData(protocolsData)
        if (text === 'updatevalues') {
          setProtocols(protocolsData)
        }
      }
    })
  }


  const updateProtocolData = (body) => {
    updateProtocolActions(body, (response) => {
      if (response.status === 200) {
        ProtocolDetails(0, 'updatevalues');
      }
    })
  }

  const trimProtocolData = (protocolsData) => {
    const trimmedProtocolsData = Array.isArray(protocolsData)
      ? protocolsData.map(item => {
        if (typeof item === 'object' && item !== null) {
          const trimmedItem = {};
          Object.keys(item).forEach(key => {
            trimmedItem[key] =
              typeof item[key] === 'string' ? item[key].trim() : item[key];
          });
          return trimmedItem;
        }
        return item;
      })
      : protocolsData;
    return trimmedProtocolsData;
  }


  const handleProtocolUpdate = (type, index) => {
    if (type === 'edit') {
      setDetectionTypeExistsError(false)
      setDetectionTypeError(false)
      setAction1Error(false)

      if (isEdited) {
        const currentData = displayedData[indexHist];
        if (JSON.stringify(originalData) !== JSON.stringify(currentData)) {
          const updatedData = [...displayedData];
          updatedData[indexHist] = originalData;
          setData(updatedData);
        }
      }
      setOriginalData(JSON.parse(JSON.stringify(displayedData[index])));
      setIsEdited(true)
      setIndexHist(index)
    }
    else if (type === 'delete') {

      const currentData = displayedData[index];
      ////console.log(typeof(currentData))
      if (Object.keys(currentData).length !== 0) {
        let protocolId = currentData.Id
        setDelPopUp(true)
        setDelIndex(protocolId)
      }
    }
    else if (type === 'save') {
      let body = data[index]
      // console.log(body)
      let hasError = false
      if (body) {

        // Apply additional conditions to the 'body' object before proceed
        // Remove leading/trailing whitespace from all string fields
        Object.keys(body).forEach(key => {
          if (typeof body[key] === 'string') {
            body[key] = body[key].trim();
          }
        });

        if (!body.DetectionType) {
          hasError = true
          setDetectionTypeError(true);
        } else {
          setDetectionTypeError(false);
        }

        if (!body.Action1) {
          hasError = true
          setAction1Error(true);
        } else {
          setAction1Error(false);
        }

        if (data.length > 0) {

          const isTypeAvailable = data.filter(item =>
            String(item.DetectionType).trim().toLowerCase() ===
            String(body.DetectionType).trim().toLowerCase() &&
            Number(item.Id) !== Number(body.Id)
          );

          if (isTypeAvailable.length > 0) {
            hasError = true
            setDetectionTypeExistsError(true)
          } else {
            setDetectionTypeExistsError(false)
          }
        } else {
          setDetectionTypeExistsError(false)
        }
      }

      if (hasError) {
        return
      }

      updateProtocolData(body)
      setIsEdited(false)
      setIndexHist(null);
    }
  }


  const addProtocols = () => {
    const newErrors = {};
    ////console.log(formDetails)
    Object.keys(formDetails).forEach(key => {

      // Trim all string fields in formDetails
      Object.keys(formDetails).forEach(key => {
        if (typeof formDetails[key] === 'string' && formDetails[key] !== '') {
          formDetails[key] = formDetails[key].trim();
        }
      });
      //console.log(key)
      if (
        (key === 'action1' || key === 'detectionType') && !formDetails[key]
      ) {
        // Custom label mapping to enforce 'Action1' -> 'Action 1'
        let label;
        if (key.toLowerCase() === 'action1') {
          label = 'Action 1';
        } else if (key.toLowerCase() === 'detectiontype') {
          label = 'Detection Type';
        } else {
          label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
        }
        newErrors[key] = `${label} is required`;
      }
    });

    if (data.length > 0) {
      const isTypeAvailable = data.filter(item =>
        String(item.DetectionType).trim().toLowerCase() ===
        String(formDetails.detectionType).trim().toLowerCase()
      );

      if (isTypeAvailable.length > 0) {
        newErrors['detectionType'] = `Detection Type already exists`;
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const body = {
      DetectionType: formDetails.detectionType,
      Action1: formDetails.action1,
      Action2: formDetails.action2,
      Action3: formDetails.action3,
      Action4: formDetails.action4,
      Exception: formDetails.exception,
    };

    console.log(body);

    addProtocolActions(body, (response) => {
      if (response.status === 200) {
        ProtocolDetails(0, 'updatevalues')
        clearValues();
      }
    })


  }

  const [isEdited, setIsEdited] = useState(false)
  const [isClientProtocolEdited, setIsClientProtocolEdited] = useState(false)
  const [indexHist, setIndexHist] = useState(null)


  const [delPopUp, setDelPopUp] = useState(false)
  const [delIndex, setDelIndex] = useState(null)

  const [itemSelectedId, setItemSelectedId] = useState(null);
  const [delClientPopUp, setDelClientPopUp] = useState(false)
  const [delClientIndex, setDelClientIndex] = useState(null)

  const handleProtocolDelete = () => {
    let body = { "Id": delIndex }
    deleteProtocolActions(body, (response) => {
      if (response.status === 200) {
        ProtocolDetails(0, 'updatevalues')
        setDelPopUp(false)
        setDelIndex(null);
      }
    })
  }

  const updateClientProtocolData = (body) => {
    console.log('handleClientProtocolDelete body:', JSON.stringify(body));
    const { DeviceId, DetectionTypeId, DetectionType, devicename, ...filteredBody } = body;
    console.log('filteredBody:', JSON.stringify(filteredBody))
    updateClientProtocolActions(body, (response) => {
      if (response.status === 200) {
        clientProtocolListing();
      }
    })
  }

  const handleClientProtocolDelete = () => {
    let body = { "Id": delClientIndex }
    console.log('handleClientProtocolDelete body:', JSON.stringify(body));
    deleteClientProtocolActions(body, (response) => {
      if (response.status === 200) {
        clientProtocolListing();
        setDelClientPopUp(false);
        setDelClientIndex(null);
      }
    })
  }


  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const handleChangePage = (event, newPage) => {
  //    setPage(newPage);
  //  };

  // const handleChangeRowsPerPage = (event) => {
  //    setRowsPerPage(parseInt(event.target.value, 10));
  //    setPage(0);   };

  // const displayedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const clearClientProtocolData = () => {
    setIsClientProtocolEdited(false)
    setOriginalProtocolData([]);
    setClientProtocolAction1Error(false);
    setItemSelectedId(null)
  }

  const handleClientProtocolUpdate = (type, itemId) => {
    console.log('itemId:', itemId);
    if (type === 'edit') {
      setIsClientProtocolEdited(true);
      const currentClientProtocolData = assignedProtocols.filter(item => item.Id === itemId)
      setOriginalProtocolData(JSON.parse(JSON.stringify(currentClientProtocolData)));
      setClientProtocolAction1Error(false);
      setItemSelectedId(itemId)
    }
    else if (type === 'delete') {
      setDelClientPopUp(true)
      setDelClientIndex(itemId)
    }
    else if (type === 'save') {
      let body = originalProtocolData[0];
      let hasError = false
      if (body) {
        Object.keys(body).forEach(key => {
          if (typeof body[key] === 'string') {
            body[key] = body[key].trim();
          }
        });

        if (!body.Action1) {
          hasError = true
          setClientProtocolAction1Error(true);
        } else {
          setClientProtocolAction1Error(false);
        }
      }

      if (hasError) {
        return
      }

      updateClientProtocolData(body)
      clearClientProtocolData();
    }
  }

  const handleGroupChange = (_, value) => {
    setSelectedGroupOption(value || null)
    if (value) {
      setActiveCameras([])
      setActiveProto([])
      setCheckProtoValue(false)
      setAssignedProtocols([])
      setCheckValue(false)
      if (groupCamerasInfo.length > 0) {
        const groupDetails = groupCamerasInfo.filter((item) => item.GroupId === value.GroupId)
        setCamsList(groupDetails)
      }
    }
    else {
      setActiveCameras([])
      setActiveProto([])
      setCheckProtoValue(false)
      setAssignedProtocols([])
      setCheckValue(false)
      setCamsList([])
    }
  }


  const handleClientType = (event) => {
    // console.log("client type",event.target.value)
    setActiveProto([])
    setCheckProtoValue(false)
    setAssignedProtocols([])
    setActiveCameras([])
    setSelectedProtocol([])
    setGroupList([])
    setPoliceNo('')
    setMobileNo('')
    setEmail('')
    setAddress('')
    setFireNo('')
    setCamsList([])
    setCheckValue(false)
    ProtocolDetails(0)
    setGroupCamersInfo([])
    setSelectedGroupOption(null)
    setClientLocationOptions([])
    setSelectedClientLocations([])
    setLocationCheckValue(false)
    setOpenAuto(false)
    selectedClientName([])

    setClientType(event.target.value)
  }

  const normalizeDisplayName = (name) =>
    String(name || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();
  
    const buildUniqueClientOptions = (clients) => {
      
      const grouped = new Map();
  
      (clients || []).forEach((clientItem) => {
        const key = normalizeDisplayName(clientItem?.displayname);
        if (!key) return;
  
        if (!grouped.has(key)) {
          grouped.set(key, []);
        }
        grouped.get(key).push(clientItem);
      });
  
      return Array.from(grouped.values()).map((groupItems) => {
        if (groupItems.length === 1) return groupItems[0];
  
        const assignTargets = new Set(
          groupItems
            .map((item) => Number(item.AssignClient || 0))
            .filter((assignId) => assignId > 0)
        );
  
        const mappedMain = groupItems.find((item) => assignTargets.has(Number(item.ID)));
        if (mappedMain) return mappedMain;
  
        const rootEntry = groupItems.find((item) => Number(item.AssignClient || 0) === 0);
        return rootEntry || groupItems[0];
      });
    };
  
  const uniqueClientOptions = useMemo(
      () => buildUniqueClientOptions(setTypeClient || []),
      [setTypeClient]
    );

  const showLocationDropdown = Boolean(clientName?.ID && clientLocationOptions.length > 0);
  const showGroupDropdown = groupList.length > 0;
  const compactAssignLayout = showLocationDropdown || showGroupDropdown;
  const assignFieldSx = {
    flexBasis: {
      xs: '100%',
      sm: '50%',
      lg: isReseller
        ? (compactAssignLayout ? '20%' : '33.3333%')
        : (compactAssignLayout ? '16.6667%' : '25%'),
    },
    maxWidth: {
      xs: '100%',
      sm: '50%',
      lg: isReseller
        ? (compactAssignLayout ? '20%' : '33.3333%')
        : (compactAssignLayout ? '16.6667%' : '25%'),
    },
  };

  return (
    <Page title="Protocols">
      <Container maxWidth="xxl" sx={{ p: 0 }}>
        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Protocols</Typography>
          </Box>
          <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
            <Typography color="text.secondary" sx={{ fontSize: '0.875rem' }}>
              Settings
            </Typography>
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>
              Protocols
            </Typography>
          </Breadcrumbs>
        </Box>

        <Card>
          <TabContext value={value}>
            <TabList
              onChange={handleChange}
              aria-label="wrapped label tabs example"
              sx={{
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                backgroundColor: (theme) => theme.palette.background.neutral,
                "& .MuiTab-root": {
                  color: (theme) => theme.palette.text.secondary, // default color for all tabs
                },
                "& .MuiTab-root.Mui-selected": {
                  color: (theme) => theme.palette.primary.main,
                },
              }}
            >
              <Tab
                value="one"
                label="Add Protocols"
                sx={{ marginRight: 10 }}
              />
              <Tab
                value="two"
                label="Assign Protocols" />
            </TabList>

          </TabContext>
        </Card>

        {addProtocol && (
          <>
            <Box>
              <Card>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={6} sm={3}>
                      <TextField
                        label='Detection Type'
                        value={formDetails.detectionType}
                        onChange={(e) => handleFormChange(e, 'detectionType')}
                        error={!!errors.detectionType}
                        helperText={errors.detectionType}
                        autoComplete="off"
                        fullWidth
                      />
                    </Grid>
                    {[1, 2, 3, 4].map((num) => (
                      <Grid item xs={6} sm={3} key={`action${num}`}>
                        <TextField
                          label={`Action ${num}`}
                          value={formDetails[`action${num}`] || ''}
                          onChange={(e) => handleFormChange(e, `action${num}`)}
                          error={!!errors[`action${num}`]}
                          helperText={errors[`action${num}`]}
                          autoComplete="off"
                          fullWidth
                        />
                      </Grid>
                    ))}

                    <Grid item xs={6} sm={3}>
                      <TextField
                        label='Exception'
                        value={formDetails.exception}
                        onChange={(e) => handleFormChange(e, 'exception')}
                        error={!!errors.exception}
                        helperText={errors.exception}
                        autoComplete="off"
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={6} sm={1} mt={1}>
                      <Button variant='contained' onClick={addProtocols}>Submit</Button>
                    </Grid>
                    <Grid item xs={6} sm={1} mt={1}>
                      <Button color="error" variant="contained" onClick={clearValues}>Clear</Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Box>

            <Box mt={1}>
              <Card>
                <CardContent>
                  <Scrollbar>
                    <TableContainer sx={{ minWidth: 800, maxHeight: 400 }}>
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow sx={{ backgroundColor: (theme) => theme.palette.background.neutral }}>
                            <TableCell align="center">S.No</TableCell>
                            <TableCell align="center">Detection Type</TableCell>
                            <TableCell align="center">Steps</TableCell>
                            <TableCell align="center">Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {displayedData.length > 0 ? (
                            displayedData.map((item, index) => (
                              <TableRow key={index}>
                                {/* Serial number */}
                                <TableCell align="center">{index + 1}</TableCell>

                                {/* Detection Type */}
                                <TableCell align="center">
                                  {indexHist === index ? (
                                    <TextField
                                      label="Detection Type"
                                      value={item.DetectionType}
                                      onChange={(e) => {
                                        const newData = [...data];
                                        newData[index].DetectionType = e.target.value;
                                        setData(newData);
                                      }}
                                      error={(detectionTypeError || detectionTypeExistsError) && indexHist === index}
                                      helperText={
                                        detectionTypeError && indexHist === index
                                          ? "Detection Type is required"
                                          : detectionTypeExistsError && indexHist === index
                                            ? "Detection Type already exists"
                                            : ""
                                      }
                                    />
                                  ) : (
                                    item.DetectionType
                                  )}
                                </TableCell>

                                {/* Actions + Exception */}
                                <TableCell
                                  align="center"
                                  sx={{
                                    width: "500px",
                                    overflow: "hidden",
                                    wordWrap: "break-word",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  {indexHist === index ? (
                                    // ✅ Wrapped both Boxes inside a fragment
                                    <>
                                      <Box display="flex" flexDirection="column" gap={1}>
                                        {[1, 2, 3, 4].map((actionNum) => {
                                          const field = `Action${actionNum}`;
                                          const label = `Action ${actionNum}`;
                                          return (
                                            <TextField
                                              key={field}
                                              value={item[field] || ""}
                                              onChange={(e) => {
                                                const newData = [...data];
                                                newData[index][field] = e.target.value;
                                                setData(newData);
                                              }}
                                              label={label}
                                              fullWidth
                                              error={actionNum === 1 && action1Error && indexHist === index}
                                              helperText={
                                                actionNum === 1 && action1Error && indexHist === index
                                                  ? "Action 1 is required"
                                                  : ""
                                              }
                                              sx={{ my: "5px" }}
                                            />
                                          );
                                        })}
                                      </Box>

                                      <Box display="flex" flexDirection="column" gap={1} sx={{ mt: "10px" }}>
                                        <TextField
                                          label="Exception"
                                          value={item["Exception"] || ""}
                                          onChange={(e) => {
                                            const newData = [...data];
                                            newData[index].Exception = e.target.value;
                                            setData(newData);
                                          }}
                                          fullWidth
                                          sx={{ my: "5px" }}
                                        />
                                      </Box>
                                    </>
                                  ) : (
                                    // ✅ Wrapped multiple sections in a fragment
                                    <>
                                      <Box display="flex" flexDirection="column" gap={1} textAlign="left">
                                        {[1, 2, 3, 4].map((actionNum) => {
                                          const field = `Action${actionNum}`;
                                          return (
                                            item[field] && (
                                              <span key={field}>
                                                <Box component="span" sx={{ color: 'primary.main', pr: '5px' }}>
                                                  {`Action ${actionNum}:`}
                                                </Box>
                                                {item[field]}
                                              </span>
                                            )
                                          );
                                        })}
                                      </Box>

                                      {item["Exception"] && (
                                        <Box
                                          display="flex"
                                          flexDirection="column"
                                          gap={1}
                                          textAlign="left"
                                          sx={{ mt: "10px" }}
                                        >
                                          <span>
                                            <Box component="span" sx={{ color: 'primary.main', pr: '5px' }}>
                                              Exception:
                                            </Box>
                                            {item["Exception"]}
                                          </span>
                                        </Box>
                                      )}
                                    </>
                                  )}
                                </TableCell>

                                {/* Action Buttons */}
                                <TableCell align="center">
                                  {indexHist === index ? (
                                    <Box display="flex" justifyContent="center" gap={1}>
                                      <Button
                                        variant="contained"
                                        onClick={() => handleProtocolUpdate("save", index)}
                                      >
                                        Save
                                      </Button>
                                      <Button
                                        variant="contained"
                                        color="error"
                                        onClick={() => {
                                          if (isEdited) {
                                            const currentData = displayedData[indexHist];
                                            if (JSON.stringify(originalData) !== JSON.stringify(currentData)) {
                                              const updatedData = [...displayedData];
                                              updatedData[indexHist] = originalData;
                                              setData(updatedData);
                                            }
                                          }
                                          setIsEdited(false);
                                          setIndexHist(null);
                                          setOpenError(false);
                                          setErrorCams("");
                                        }}
                                        sx={{ marginLeft: "3px" }}
                                      >
                                        Cancel
                                      </Button>
                                    </Box>
                                  ) : (
                                    <Box display="flex" justifyContent="center" gap={1}>
                                      <Button
                                        variant="contained"
                                        onClick={() => handleProtocolUpdate("edit", index)}
                                      >
                                        Edit
                                      </Button>
                                      <Button
                                        variant="contained"
                                        color="error"
                                        onClick={() => handleProtocolUpdate("delete", index)}
                                        sx={{ marginLeft: "3px" }}
                                      >
                                        Remove
                                      </Button>
                                    </Box>
                                  )}
                                </TableCell>
                              </TableRow>
                            ))
                          )
                            : (
                              <TableRow>
                                <TableCell colSpan={6} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                  No Data
                                </TableCell>
                              </TableRow>
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Scrollbar>
                </CardContent>
              </Card>
            </Box>
          </>
        )}

        {assignProtocol && (<Box>
          <Card style={{ marginBottom: '5px' }}>
            <CardContent style={{ marginBottom: '-25px' }}>
              <Grid container spacing={2} alignItems="flex-start">
                {!isReseller && (<Grid item sx={assignFieldSx}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-labell">Client Type</InputLabel>
                    <Select

                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={clientType}
                      label="Client Type"
                      onChange={handleClientType}
                      error={clientTypeerror && !clientType}
                    // helperText={touched.ClientType && errors.ClientType}
                    >

                      <MenuItem value="US">US</MenuItem>
                      <MenuItem value="INDIA">INDIA</MenuItem>

                    </Select>

                    {(clientTypeerror && !clientType) && ( // Show error message if saveError and !isClientSelected
                      <Typography variant="body2" color="error">
                        Please select a client.
                      </Typography>
                    )}
                  </FormControl>


                </Grid>)}
                <Grid item sx={assignFieldSx}>
                  <FormControl fullWidth>

                    <Autocomplete
                      id="tags-outlined-client"
                      options={uniqueClientOptions.map((clientItem, clientIndex) => ({
                        ...clientItem,
                        customKey: `${clientItem.ID || clientItem.id}-${clientIndex}`,
                      }))}
                      isOptionEqualToValue={(option, value) =>
                        option.ID === value.ID
                      }
                      getOptionLabel={(option) =>  `${option.displayname}`}
                      value={clientName?.ID ? uniqueClientOptions.find((option) => option.ID === clientName.ID) || null : null}
                      onChange={(e, val) => {
                        setProtocolInfo('')
                        handleClient(e, val)
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Client"
                          placeholder="Search Client Name..."
                          error={saveError && !isClientSelected} // Add error state based on saveError and isClientSelected
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props} key={option.customKey}>
                          {option.displayname}
                        </li>
                      )}
                    />
                    {(saveError && !isClientSelected) && ( // Show error message if saveError and !isClientSelected
                      <Typography variant="body2" color="error">
                        Please select a client.
                      </Typography>
                    )}

                  </FormControl>
                </Grid>
                {showLocationDropdown && (
                  <Grid item sx={assignFieldSx}>
                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        id="protocol-location-filter"
                        options={clientLocationOptions}
                        value={clientLocationOptions.filter((locationItem) =>
                          selectedClientLocations.includes(locationItem.ID || locationItem.id)
                        )}
                        getOptionLabel={(option) => option.selectall ? option.title : `${option.Location || ''}`}
                        onChange={handleLocationChange}
                        disableCloseOnSelect
                        filterOptions={handleLocationFilterOptions}
                        renderTags={() => null}
                        renderOption={(props, option) => (
                          <li {...props}>
                            {option.selectall ? (
                              <>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={locationCheckValue}
                                />
                                {option.title}
                              </>
                            ) : (
                              <>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={selectedClientLocations.includes(option.ID || option.id)}
                                />
                                {option.Location}
                              </>
                            )}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} label="Locations" placeholder="Select Locations" />
                        )}
                      />
                    </FormControl>
                  </Grid>
                )}
                {showGroupDropdown && (<Grid item sx={assignFieldSx}>
                  <FormControl fullWidth>
                    <Autocomplete
                      options={groupList}
                      value={selectedGroupOption}
                      renderInput={(params) => <TextField {...params} label="Select Group" variant="outlined" />}
                      freeSolo
                      onChange={handleGroupChange}
                      renderOption={(props, option) => (
                        <li {...props} key={option.GroupId}>
                          {option.GroupName}
                        </li>
                      )}
                      getOptionLabel={(option) => `${option.GroupName}`}
                    />
                  </FormControl>
                </Grid>)}
                <Grid item sx={assignFieldSx}>
                  <FormControl fullWidth>
                    <Autocomplete
                      multiple
                      id="tags-outlined-client"
                      options={selectedCamesList}
                      //getOptionLabel={(option) => `${option.deviceid} ${option.devicename}`}
                      onChange={handleCamera}
                      //value={selectedCamItems}

                      //value={(checkValue) ? [{ title: 'Select All', all: true }] : inputValue.filter((camera) => activeCameras.includes(camera.deviceid))}
                      value={[]}

                      getOptionLabel={(option) => (option.selectall && selectedCamesList.length === activeCameras.length) ? 'Select All' : `${option.deviceid} ${option.devicename}`}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Cameras"
                          placeholder="Search Camera Name..."
                        />
                      )}

                      disableCloseOnSelect={openAuto}
                      open={openAuto}
                      onOpen={() => setOpenAuto(true)}
                      onClose={() => setOpenAuto(false)}

                      // filterOptions={(options, params) => {
                      //   const filter = createFilterOptions();
                      //   const filtered = filter(options, params);
                      //   return [{ title: 'Select All', selectall: true }, ...filtered];
                      // }}

                      filterOptions={handleFilterOptions}

                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          {option.selectall ? (
                            <>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={checkValue}
                              //onChange={() => setCheckValue(!checkValue)}
                              />
                              {option.title}
                            </>
                          ) : (
                            <>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={activeCameras.includes(option.deviceid)}
                                onChange={() => {
                                  const isChecked = activeCameras.includes(option.deviceid);
                                  const newActiveCameras = isChecked
                                    ? activeCameras.filter((deviceId) => deviceId !== option.deviceid)
                                    : [...activeCameras, option.deviceid];
                                  setActiveCameras(newActiveCameras);
                                }}
                              />
                              {`${option.devicename}`}
                            </>
                          )}
                        </li>
                      )}
                      //getOptionKey={(option) => option.deviceid}
                      isOptionEqualToValue={(option, value) => option.deviceid === value.deviceid}
                    />
                  </FormControl>
                </Grid>
                <Grid item sx={assignFieldSx}>
                  <FormControl fullWidth>
                    <Autocomplete
                      multiple
                      id="tags-outlined-client"
                      options={selectedCamesList.length > 0 ? protocolList : []}
                      onChange={handleProtocol}
                      value={[]}
                      getOptionLabel={(option) => (option.selectall && protocolList.length === activeProto.length) ? 'Select All' : `${option.DetectionType}`}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Protocol"
                          placeholder="Search Protocol Name..."
                        />
                      )}
                      disableCloseOnSelect
                      filterOptions={(options, params) => {
                        const filter = createFilterOptions();
                        const filtered = filter(options, params);
                        return [{ title: 'Select All', selectall: true }, ...filtered];
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          {option.selectall ? (
                            <>
                              <Checkbox
                                icon={protoIcon}
                                checkedIcon={protoCheckedIcon}
                                style={{ marginRight: 8 }}
                                checked={checkProtoValue}
                              />
                              {option.title}
                            </>
                          ) : (
                            <>
                              <Checkbox
                                icon={protoIcon}
                                checkedIcon={protoCheckedIcon}
                                style={{ marginRight: 8 }}
                                checked={activeProto.includes(option.Id)}
                                onChange={() => {
                                  const isChecked = activeProto.includes(option.Id);
                                  const newActiveProtocols = isChecked
                                    ? activeProto.filter((val) => val !== option.Id)
                                    : [...activeProto, option.Id];
                                  setActiveProto(newActiveProtocols);
                                }}
                              />
                              {`${option.DetectionType}`}
                            </>
                          )}
                        </li>
                      )}
                      isOptionEqualToValue={(option, value) => option.Id === value.Id}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
            <CardContent style={{ marginBottom: '-16px' }}>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} lg={3}>
                  <InputLabel shrink>
                    Police Number
                  </InputLabel>
                  <Box
                    sx={{
                      border: (theme) => `1px solid ${theme.palette.divider}`,
                      padding: '8px',
                      borderRadius: '8px',
                      minHeight: isClientSelected && clientInfo.length == 1 && policeno && !lastNumber ? 'auto' : '50px',
                    }}
                    onClick={() => handleBoxClick('policeno')}
                  >
                    {!lastNumber && isClientSelected && policeno.split(',').map((policeNumber, index) => (
                      <Box
                        key={index}
                        sx={{
                          marginBottom: 1,
                          width: '80%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          position: 'relative',
                          borderRadius: '100px',
                          border: 'none',
                        }}
                      >
                        <TextField
                          placeholder='Add Police Number'
                          value={policeNumber}
                          onClick={(e) => {
                            e.stopPropagation()
                          }}
                          onChange={(e) => handleNumberChange(e, index, 'police')}
                          fullWidth
                          size="small"
                          sx={{
                            '& input': {
                              height: '14px',
                              fontSize: '14px',
                              color: (theme) => theme.palette.text.primary,
                              "&::placeholder": {
                                color: (theme) => theme.palette.text.secondary,
                                opacity: 1,
                              },
                            },
                            '& fieldset': {
                              border: 'none'
                            },
                          }}
                        />
                        <Box
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            right: '8px',
                            transform: 'translateY(-50%)',
                            width: '15px',
                            height: '15px',
                            borderRadius: '50%',
                            backgroundColor: (theme) => theme.palette.action.selected,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}>
                          <IconButton
                            onClick={(e) => removeNumber(e, index, 'policeNumber')}
                          >
                            <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                          </IconButton>
                        </Box>
                      </Box>
                    ))}

                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} lg={3}>
                  <InputLabel shrink>
                    Email
                  </InputLabel>
                  <Box
                    sx={{
                      border: (theme) => `1px solid ${theme.palette.divider}`,
                      padding: '8px',
                      borderRadius: '8px',
                      minHeight: isClientSelected && clientInfo.length == 1 && email && !lastEmail ? 'auto' : '50px'
                    }}
                    onClick={() => handleBoxClick('email')}
                  >
                    {!lastEmail && isClientSelected && email.split(',').map((email, index) => (
                      <Box
                        key={index}
                        sx={{
                          marginBottom: 1,
                          width: '80%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          borderRadius: '100px',
                          position: 'relative',
                          border: 'none'
                        }}
                      >
                        <TextField
                          placeholder='Add Email'
                          value={email}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => handleNumberChange(e, index, 'email')}
                          fullWidth
                          size="small"
                          sx={{
                            '& input': {
                              height: '14px',
                              fontSize: '14px',
                              color: (theme) => theme.palette.text.primary,
                              "&::placeholder": {
                                color: (theme) => theme.palette.text.secondary,
                                opacity: 1,
                              },
                            },
                            '& fieldset': {
                              borderRadius: 50,
                              border: 'none'
                            }
                          }}
                        />
                        <Box
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            right: '8px',
                            transform: 'translateY(-50%)',
                            width: '15px',
                            height: '15px',
                            borderRadius: '50%',
                            backgroundColor: (theme) => theme.palette.action.selected,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <IconButton
                            sx={{
                              position: 'absolute',
                              top: '-8px',
                              right: '-8px',
                            }}
                            onClick={(e) => removeNumber(e, index, 'email')}
                          >
                            <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                          </IconButton>
                        </Box>
                      </Box>
                    ))}

                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} lg={3}>
                  <InputLabel shrink>
                    Contact Number
                  </InputLabel>
                  <Box
                    sx={{
                      border: (theme) => `1px solid ${theme.palette.divider}`,
                      padding: '8px',
                      borderRadius: '8px',
                      minHeight: isClientSelected && clientInfo.length == 1 && mobileno && !lastContact ? 'auto' : '50px',
                    }}
                    onClick={() => handleBoxClick('mobileno')}
                  >
                    {!lastContact && isClientSelected && mobileno.split(',').map((mobile, index) => (
                      <Box
                        key={index}
                        sx={{
                          marginBottom: 1,
                          width: '80%',
                          backgroundColor: (theme) => theme.palette.action.selected,
                          borderRadius: '100px',
                          border: 'none',
                          position: 'relative',
                        }}
                      >
                        <TextField
                          placeholder='Add Contact Number'
                          value={mobile}
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => handleNumberChange(e, index, 'mobile')}
                          fullWidth
                          size="small"
                          sx={{
                            '& input': {
                              height: '14px',
                              fontSize: '14px',
                              color: (theme) => theme.palette.text.primary,
                              "&::placeholder": {
                                color: (theme) => theme.palette.text.secondary,
                                opacity: 1,
                              },
                            },
                            '& fieldset': {
                              borderRadius: 50,
                              border: 'none'
                            }
                          }}
                        />
                        <Box
                          sx={{
                            position: 'absolute',
                            top: '50%',
                            right: '8px',
                            transform: 'translateY(-50%)',
                            width: '15px',
                            height: '15px',
                            borderRadius: '50%',
                            backgroundColor: (theme) => theme.palette.action.selected,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                        >
                          <IconButton
                            sx={{
                              position: 'absolute',
                              top: '-8px',
                              right: '-8px',
                            }}
                            onClick={(e) => removeNumber(e, index, 'mobile')}
                          >
                            <CloseIcon fontSize="small" sx={{ fontSize: '14px', color: 'text.secondary' }} />
                          </IconButton>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Grid>

                {renderMultiValueField({
                  label: 'Primary SPOC',
                  value: primarySpocContact,
                  lastValueRemoved: lastPrimarySpoc,
                  clickKey: 'primarySpocContact',
                  changeType: 'primarySpocContact',
                  removeType: 'primarySpocContact',
                  placeholder: 'Add Primary SPOC',
                })}

                {renderMultiValueField({
                  label: 'Secondary POC',
                  value: secondaryPocContact,
                  lastValueRemoved: lastSecondaryPoc,
                  clickKey: 'secondaryPocContact',
                  changeType: 'secondaryPocContact',
                  removeType: 'secondaryPocContact',
                  placeholder: 'Add Secondary POC',
                })}

                {renderMultiValueField({
                  label: 'Onsite- Maintenance/Installation Support/Downtime',
                  value: onsiteMaintenanceSupportContact,
                  lastValueRemoved: lastOnsiteMaintenance,
                  clickKey: 'onsiteMaintenanceSupportContact',
                  changeType: 'onsiteMaintenanceSupportContact',
                  removeType: 'onsiteMaintenanceSupportContact',
                  placeholder: 'Add Onsite Maintenance/Installation Support/Downtime',
                })}

                {renderMultiValueField({
                  label: 'Onsite - Speaker Testing-SPOC',
                  value: onsiteSpeakerTestingSpoc,
                  lastValueRemoved: lastOnsiteSpeakerTesting,
                  clickKey: 'onsiteSpeakerTestingSpoc',
                  changeType: 'onsiteSpeakerTestingSpoc',
                  removeType: 'onsiteSpeakerTestingSpoc',
                  placeholder: 'Add Onsite Speaker Testing-SPOC',
                })}

                {renderMultiValueField({
                  label: 'Local Non Emergency',
                  value: localNonEmergencyContact,
                  lastValueRemoved: lastLocalNonEmergency,
                  clickKey: 'localNonEmergencyContact',
                  changeType: 'localNonEmergencyContact',
                  removeType: 'localNonEmergencyContact',
                  placeholder: 'Add Local Non Emergency',
                })}

                {renderMultiValueField({
                  label: 'Fire Department',
                  value: fireDepartmentContact,
                  lastValueRemoved: lastFireDepartment,
                  clickKey: 'fireDepartmentContact',
                  changeType: 'fireDepartmentContact',
                  removeType: 'fireDepartmentContact',
                  placeholder: 'Add Fire Department',
                })}

                {renderMultiValueField({
                  label: 'Other Security/Patrol',
                  value: securityPatrolContact,
                  lastValueRemoved: lastSecurityPatrol,
                  clickKey: 'securityPatrolContact',
                  changeType: 'securityPatrolContact',
                  removeType: 'securityPatrolContact',
                  placeholder: 'Add Other Security/Patrol',
                })}

                <Grid item xs={12} lg={6}>
                  <InputLabel shrink>
                    Address
                  </InputLabel>
                  <TextField
                    fullWidth
                    value={address}
                    onChange={handleAddressChange}
                    InputLabelProps={{
                      shrink: !!address,
                    }}
                    sx={{
                      '& input': {
                        //height: '10px', 
                        fontSize: '14px',
                      }
                    }}
                  />

                </Grid>

              </Grid>
              {/* <Grid sx={{marginTop:'1rem'}}>
            
            </Grid> */}
            </CardContent>
            <DialogActions sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              <LoadingButton
                type="submit"
                onClick={handleProtocolSave}
                variant="contained"
                sx={{ mr: 4, mb: 2 }}
              >
                Save
              </LoadingButton>
              {showMessage && <Typography sx={{ color: 'success.main' }}>Details Updated Successfully!!!</Typography>}
            </DialogActions>
          </Card>

          <Card>
            <CardContent style={{ marginBottom: '-16px' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                <Typography variant="h4">
                  Protocols
                </Typography>
              </Stack>

              {deviceDataExist && activeCameras.length !== 0 ? (
                Object.entries(groupMessagesByDeviceId(assignedProtocols)).map(([DeviceId, messagesForDevice]) => {
                  return (
                    <React.Fragment key={`device-group-${DeviceId}`}>
                      <Card sx={{ margin: '10px' }}>
                        <CardContent sx={{ padding: '0px', '&:last-child': { paddingBottom: 0 } }}>
                          <Scrollbar>
                            <Box
                              component="h2"
                              sx={{
                                color: 'text.primary',
                                py: '10px',
                                px: '35px',
                                backgroundColor: 'background.neutral',
                                m: 0,
                              }}
                            >
                              {messagesForDevice[0]['devicename']}
                            </Box>
                            <TableContainer sx={{ minWidth: 800, maxHeight: 400 }}>
                              <Table stickyHeader>
                                <TableHead>
                                  <TableRow sx={{ backgroundColor: (theme) => theme.palette.background.neutral }}>
                                    <TableCell align="center">S.No</TableCell>
                                    <TableCell align="center">Detection Type</TableCell>
                                    <TableCell align="center">Steps</TableCell>
                                    <TableCell align="center">Action</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {messagesForDevice.length > 0 ? (
                                    messagesForDevice.map((item, index) => {
                                      const itemId = item.Id || `row-${DeviceId}-${index}`; // ✅ fully unique fallback

                                      return (
                                        <TableRow key={itemId}>
                                          <TableCell align="center">{index + 1}</TableCell>
                                          <TableCell align="center">{item.DetectionType}</TableCell>

                                          <TableCell
                                            align="center"
                                            sx={{ width: '500px', overflow: 'hidden', wordWrap: 'break-word', whiteSpace: 'normal' }}
                                          >
                                            {itemSelectedId === itemId ? (
                                              <>
                                                <Box display="flex" flexDirection="column" gap={1}>
                                                  {[1, 2, 3, 4].map((actionNum) => {
                                                    const field = `Action${actionNum}`;
                                                    const label = `Action ${actionNum}`;
                                                    return (
                                                      <TextField
                                                        key={`${itemId}-${field}`} // ✅ unique key
                                                        value={originalProtocolData[0][field] || ""}
                                                        onChange={(e) => {
                                                          const newData = [...originalProtocolData];
                                                          newData[0][field] = e.target.value;
                                                          setOriginalProtocolData(newData);
                                                        }}
                                                        label={label}
                                                        fullWidth
                                                        error={actionNum === 1 && clientProtocolAction1Error && itemSelectedId === itemId}
                                                        helperText={actionNum === 1 && clientProtocolAction1Error && itemSelectedId === itemId ? "Action 1 is required" : ""}
                                                        sx={{ my: '5px' }}
                                                      />
                                                    );
                                                  })}
                                                </Box>

                                                <Box display="flex" flexDirection="column" gap={1} sx={{ mt: '10px' }}>
                                                  <TextField
                                                    key={`${itemId}-Exception`}
                                                    label="Exception"
                                                    value={originalProtocolData[0]['Exception'] || ""}
                                                    onChange={(e) => {
                                                      const newData = [...originalProtocolData];
                                                      newData[0]['Exception'] = e.target.value;
                                                      setOriginalProtocolData(newData);
                                                    }}
                                                    fullWidth
                                                    sx={{ my: '5px' }}
                                                  />
                                                </Box>
                                              </>
                                            ) : (
                                              <>
                                                <Box display="flex" flexDirection="column" gap={1} textAlign="left">
                                                  {[1, 2, 3, 4].map((actionNum) => {
                                                    const field = `Action${actionNum}`;
                                                    if (!item[field]) return null;
                                                    return (
                                                      <span key={`${itemId}-${field}`}>
                                                        <Box component="span" sx={{ color: 'primary.main', pr: '5px' }}>{`Action ${actionNum}:`}</Box>
                                                        {item[field]}
                                                      </span>
                                                    );
                                                  })}
                                                </Box>

                                                {item['Exception'] && (
                                                  <Box
                                                    key={`${itemId}-exception-display`}
                                                    display="flex"
                                                    flexDirection="column"
                                                    gap={1}
                                                    textAlign="left"
                                                    sx={{ mt: '10px' }}
                                                  >
                                                    <span>
                                                      <Box component="span" sx={{ color: 'primary.main', pr: '5px' }}>Exception:</Box>
                                                      {item['Exception']}
                                                    </span>
                                                  </Box>
                                                )}
                                              </>
                                            )}
                                          </TableCell>

                                          <TableCell align="center">
                                            {itemSelectedId === itemId ? (
                                              <Box display="flex" justifyContent="center" gap={1}>
                                                <Button variant='contained' onClick={() => handleClientProtocolUpdate('save', itemId)}>Save</Button>
                                                <Button variant='contained' color="error" onClick={clearClientProtocolData} sx={{ marginLeft: '3px' }}>
                                                  Cancel
                                                </Button>
                                              </Box>
                                            ) : (
                                              <Box display="flex" justifyContent="center" gap={1}>
                                                <Button
                                                  variant='contained'
                                                  onClick={() => handleClientProtocolUpdate('edit', itemId)}
                                                  disabled={isClientProtocolEdited}
                                                >
                                                  Edit
                                                </Button>
                                                <Button
                                                  variant='contained'
                                                  color="error"
                                                  onClick={() => handleClientProtocolUpdate('delete', itemId)}
                                                  sx={{ marginLeft: '3px' }}
                                                  disabled={isClientProtocolEdited}
                                                >
                                                  Remove
                                                </Button>
                                              </Box>
                                            )}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })
                                  ) : (
                                    <TableRow>
                                      <TableCell colSpan={6} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        No Data
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                        </CardContent>
                      </Card>
                    </React.Fragment>

                  )
                }
                )
              ) : (
                (activeCameras.length !== 0 && activeProto.length > 0) ? (
                  <>

                    <Card>
                      <CardContent sx={{ padding: '0px', '&:last-child': { paddingBottom: 0 } }}>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 800, maxHeight: 400 }}>
                            <Table stickyHeader>
                              <TableHead >
                                <TableRow sx={{ backgroundColor: (theme) => theme.palette.background.neutral }}>
                                  <TableCell align="center">S.No</TableCell>
                                  <TableCell align="center">Detection Type</TableCell>
                                  <TableCell align="center">Steps</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {assignedProtocols.length > 0 ? (
                                  assignedProtocols.map((item, index) => (
                                    <TableRow key={index}>
                                      <TableCell align="center">{index + 1}</TableCell>
                                      <TableCell align="center">{item.DetectionType}</TableCell>
                                      <TableCell align="center" sx={{ width: '500px', overflow: 'hidden', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                        <Box display="flex" flexDirection="column" gap={1} textAlign="left">
                                          {[1, 2, 3, 4].map((actionNum, idx) => {
                                            const field = `Action${actionNum}`;
                                            return (
                                              (item[field] && (
                                                <>
                                                  <span key={idx}>
                                                    <Box component="span" sx={{ color: 'primary.main', pr: '5px' }}>{`Action ${actionNum}`}:</Box>
                                                    {item[field]}
                                                  </span>
                                                </>
                                              ))
                                            );
                                          })}
                                        </Box>

                                        {item['Exception'] &&
                                          <Box display="flex" flexDirection="column" gap={1} textAlign="left" sx={{ mt: '10px' }}>
                                            <span><Box component="span" sx={{ color: 'primary.main', pr: '5px' }}>{`Exception`}:</Box>{item['Exception']}</span>
                                          </Box>
                                        }
                                      </TableCell>
                                    </TableRow>
                                  ))
                                ) : (
                                  <TableRow>
                                    <TableCell colSpan={6} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                      No Data
                                    </TableCell>
                                  </TableRow>
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                      </CardContent>
                    </Card>

                    <DialogActions>
                      <LoadingButton
                        type="submit"
                        onClick={handleProtocolMessageSave}
                        variant="contained"
                        sx={{ mr: 1, my: 2 }}
                      >
                        Save
                      </LoadingButton>

                    </DialogActions>
                  </>
                ) : null
              )}
            </CardContent>
          </Card>
        </Box>)}


        <Dialog open={openError} onClose={handleCloseError} maxWidth="xs" fullWidth>
          <DialogTitle>{header}</DialogTitle>
          <DialogContent>
            <Typography variant='h6'>{errorCams}</Typography>
          </DialogContent>
          <DialogActions>
            {showConfirm && <Button variant="contained" onClick={deleteProtoMessage}>Ok</Button>}
            <Button color='error' onClick={handleCloseError} variant='contained' >Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={delPopUp}>
          <DialogContent>Are You Sure You Want to Delete this Protocol?</DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={handleProtocolDelete}>Ok</Button>
            <Button variant="contained" color='error' onClick={() => setDelPopUp(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={delClientPopUp}>
          <DialogContent>Are You Sure You Want to Delete this Protocol?</DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={handleClientProtocolDelete}>Ok</Button>
            <Button variant="contained" color='error' onClick={() => setDelClientPopUp(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
};

const ArrowBox = ({ field, entry, index, removeEntry }) => {
  const theme = useTheme();
  const containerStyle = {
    position: 'relative',
    width: '100%',
    marginBottom: '8px',
  };

  const boxStyle = {
    backgroundColor: theme.palette.success.lighter,
    borderRadius: '4px',
    border: `1px solid ${theme.palette.divider}`,
    padding: '10px',
    boxSizing: 'border-box',
    width: '100%',
  };

  const crossStyle = {
    position: 'absolute',
    right: '2px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: theme.palette.text.secondary,
    cursor: 'pointer',
  };

  return (
    <div style={containerStyle}>
      <div style={boxStyle}>
        <Typography variant="body1" style={{ textAlign: 'left', width: '100%' }}>
          {entry}
        </Typography>
        <IconButton
          onClick={() => removeEntry(field, index)}
          style={crossStyle}
        >
          <ClearIcon style={{ width: '15px' }} />
        </IconButton>
      </div>
    </div>
  );
};



export default Protocols;
